import { useEffect, useState } from 'react';
import { Tooltip, Box, Typography } from '@mui/material';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './config/firebaseConfig';
import useStore from './config/store';
import { useTranslation } from 'react-i18next';

const PointsUsage = () => {
  const { t } = useTranslation();
  const { organization } = useStore();
  const [pointsData, setPointsData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!organization) {
      setLoading(false);
      return;
    }

    setLoading(true);

    const unsubscribe = onSnapshot(
      doc(db, 'organization', organization),
      (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data?.points_system?.enabled) {
            setPointsData({
              used: data.points_system.points_usage || 0,
              limit: data.points_system.points_limits || 0,
              remaining:
                (data.points_system.points_limits || 0) -
                (data.points_system.points_usage || 0),
              unlimited: data.points_system.points_limits === -1,
            });
          } else {
            setPointsData(null);
          }
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [organization]);

  if (!organization || !pointsData || loading) {
    return null;
  }

  return (
    <Tooltip
      placement="left"
      componentsProps={{
        tooltip: {
          sx: {
            backgroundColor: '#6A5AF9',
            color: '#FFFFFF',
          },
        },
      }}
      title={
        <Box sx={{ p: 1 }}>
          <Typography variant="caption" display="block">
            {t('usageFAB.used')}: {pointsData.used.toFixed(2)}
          </Typography>
          <Typography variant="caption" display="block">
            {t('usageFAB.limit')}:{' '}
            {pointsData.unlimited
              ? t('usageFAB.unlimited')
              : pointsData.limit.toFixed(2)}
          </Typography>
          <Typography variant="caption" display="block" fontWeight="bold">
            {t('usageFAB.remaining')}:{' '}
            {pointsData.unlimited
              ? t('usageFAB.unlimited')
              : pointsData.remaining.toFixed(2)}
          </Typography>
        </Box>
      }
    >
      <Box
        sx={{
          px: 1.5,
          py: 0.5,
          borderRadius: 1.5,
          backgroundColor: 'rgba(255, 255, 255, 0.55)',
          border: '1px solid #D1D5DB',
          minWidth: 148,
          lineHeight: 1.1,
        }}
      >
        <Typography
          sx={{
            fontSize: '0.70rem',
            color: '#374151',
            fontWeight: 700,
            textTransform: 'uppercase',
            textAlign: 'left',
          }}
        >
          {t('usageFAB.pointsAvailableLabel')}
        </Typography>

        <Typography
          sx={{
            fontSize: '1rem',
            color: '#111827',
            fontWeight: 800,
            textAlign: 'center', // centrado del número
            width: '100%',
          }}
        >
          {pointsData.unlimited
            ? t('usageFAB.unlimited')
            : pointsData.remaining.toFixed(2)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default PointsUsage;